import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { ChartOfAccountPDFApi } from "./ChartOfAccountAction"
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { startFinancialDate, endFinancialDate } from "../../../../../global/globalFunctions";
// import _ from "lodash";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const ViewChartOfAccount = (props) => {
    const [startDate, setStartDate] = useState(startFinancialDate);
    const [endDate, setEndDate] = useState(endFinancialDate);

    const ExportPDF = () => {
        props.ChartOfAccountPDFApi({
            startDate: startDate,
            endDate: endDate,
        },
            startDate,
            endDate,
        );
    }

    useEffect(() => {
        props.setHeading("Chart Of Account");
    }, []);

    return (
        <>
            <Container fluid>
                {/* <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label><b>Start Date *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            >
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label><b>End Date *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            >
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row> */}

                <div className="sendDiv">
                    <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => ExportPDF()}><b>GENERATE PDF</b></Button>
                </div>

            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        ChartOfAccountPDFApi: (startDate, endDate) => dispatch(ChartOfAccountPDFApi(startDate, endDate)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewChartOfAccount);